// Light/Dark pill toggle — presentational only. Its look copies the existing toggle on the AI Sentry
// pages (AISentryLight.jsx's "Switch to Dark Mode" pill; AISentry.jsx's "Switch to Light Mode" colours
// for the dark state). Those pages keep their own inline copies; this one is used by Event Trace Light,
// whose toggle switches a theme on the same page rather than navigating.
import React from 'react';

const MOON = 'M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z';
const SUN = 'M12 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm0 15a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zm9-6a1 1 0 110 2h-1a1 1 0 110-2h1zM4 12a1 1 0 110 2H3a1 1 0 110-2h1zm14.95-7.364a1 1 0 010 1.414l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 0zM7.172 16.828a1 1 0 010 1.414l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 0zm9.9 0a1 1 0 011.414 0l.707.707a1 1 0 01-1.414 1.414l-.707-.707a1 1 0 010-1.414zM5.636 5.636a1 1 0 011.414 0l.707.707A1 1 0 016.343 7.757l-.707-.707a1 1 0 010-1.414zM12 7a5 5 0 100 10A5 5 0 0012 7z';

export default function ThemeToggle({ isDark = false, onToggle, className = '' }) {
  const title = isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode';
  return (
    <button
      type="button"
      onClick={onToggle}
      title={title}
      aria-label={title}
      aria-pressed={isDark}
      data-testid="theme-toggle"
      className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 transition-colors border ${
        isDark
          ? 'bg-slate-800 hover:bg-slate-700 border-slate-600'
          : 'bg-slate-100 hover:bg-slate-200 border-slate-200'
      } ${className}`}
    >
      <svg className={`w-3.5 h-3.5 ${isDark ? 'text-slate-500' : 'text-slate-400'}`} fill="currentColor" viewBox="0 0 24 24">
        <path d={MOON} />
      </svg>
      <div className={`w-8 h-4 rounded-full relative mx-0.5 ${isDark ? 'bg-slate-600' : 'bg-slate-300'}`}>
        <div className={`absolute top-0.5 w-3 h-3 rounded-full shadow-sm ${
          isDark ? 'right-0.5 bg-slate-400' : 'left-0.5 bg-white'
        }`} />
      </div>
      <svg className="w-3.5 h-3.5 text-amber-400" fill="currentColor" viewBox="0 0 24 24">
        <path d={SUN} />
      </svg>
    </button>
  );
}
